import { gql } from '@apollo/client';

/**
 * A full library row: the print/AI metadata and specs the onboarding table, the
 * onboarding art detail and the website push read. Wider than the my-artwork grid row
 * (`LibraryImageFields`), so these screens never depend on what the grid loaded.
 */
const IMAGE_ROW_FIELDS = gql`
  fragment ImageRowFields on Image {
    id
    title
    description
    status
    context
    thumbnailUrl
    optimizedUrl
    originalUrl
    originalWidth
    originalHeight
    fileMeta
    aiMeta
    printMeta
    collectionId
    height
    width
    dimensionType
    isPublic
    isNsfw
    flagReason
    slug
    artworkSpecs {
      mediumType
      camera
      lens
      focalLength
      aperture
      shutterSpeed
      iso
      medium
      technique
      subMedium
      software
      mediumCategory {
        id
      }
      hidden
    }
    tags {
      id
      name
    }
    createdAt
  }
`;

/** A page of full rows: unfiltered for onboarding, `ids` chunks for a selection, a folder for the push. */
export const IMAGE_ROWS_QUERY = gql`
  ${IMAGE_ROW_FIELDS}
  query ImageRows($first: Int, $after: String, $filter: ImageFilter) {
    myImages(first: $first, after: $after, filter: $filter) {
      edges {
        cursor
        node {
          ...ImageRowFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

/** Ids only, for a select-all that has to name every image, not just the loaded rows. */
export const IMAGE_IDS_QUERY = gql`
  query ImageIds($first: Int, $after: String, $filter: ImageFilter) {
    myImages(first: $first, after: $after, filter: $filter) {
      edges {
        cursor
        node {
          id
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
